import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { first, map, tap } from "rxjs/operators";

import { RedirectService } from "@local/app/common/redirect.service";
import { GlobalAuthService } from "@local/app/core/global-auth";

@Injectable()
export class RequireLoggedOutGuard implements CanActivate {
  constructor(
    private globalAuth: GlobalAuthService,
    private router: Router,
    private redirectService: RedirectService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.globalAuth.isLoggedIn.pipe(
      first(),
      map((isLoggedIn) => !isLoggedIn),
      tap((isLoggedOut) => {
        if (isLoggedOut) {
          return;
        }
        route.queryParams.redirect != null
          ? this.redirectService.redirect(route.queryParams.redirect)
          : this.router.navigateByUrl("/marts");
      })
    );
  }
}
